import React from 'react';
import { Modal, Button, Steps } from 'antd';
import { useState } from 'react';
// Phase C.5 (Candidate System UI Language Migration): the embedded PDF itself (Scribe_Usage_
// Guidelines.pdf, below) is out of scope per this phase's own "no PDF/rich-HTML translation" rule —
// only the button/modal chrome that triggers/closes the viewer is migrated.
import Text from 'components/Text/Text';

const ScribePdfModal = () => {
  return (
    <div>
      <iframe
        src="/Scribe_Usage_Guidelines.pdf#toolbar=0&navpanes=0&scrollbar=0"
        width="100%"
        height="900px"
        title="Scribe Usage Guidelines"
        style={{ border: 'none', margin: 0, padding: 0  }}
      ></iframe>
    </div>
    
  );
};

const ScribePdfModalViwer = () => {

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="d-flex w-100 justify-content-center">
      <div>
        <div>
          <Button
            type="primary"
            className="button-global button-primary autoWidth autoHeight"
            onClick={showModal}

          >
            <Text k="personalInfo.scribeGuidelinesButton" />
          </Button>
        </div>
      </div>
      <Modal
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[
          <Button
            key="cancel"
            onClick={handleCancel}
            className="button-global button-border autoHeight"
          >
            <Text k="homeSummary.closeButtonLabel" />
          </Button>
        ]}
        width="80%"
        height="85%"
        bodyStyle={{ padding: 0, overflow: "hidden",marginBottom: '0px', paddingBottom: '0px'  }}
        style={{ top: "5%" }}
        closable={false}

      >
        <ScribePdfModal />

      </Modal>
    </div>
  );
};

export default ScribePdfModalViwer;